module.exports = __webpack_public_path__ + "h5/img/znshj.26d0440e.jpg";